import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { EventEnum } from '@as-react/common-types';
import { useIsClient } from '@yonderland/andes-react';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useCategoryHierarchyTree } from '../../hooks/useCategoryHierarchyTree';
import { useForceUpdate } from '../../hooks/useForceUpdate';
import { makeGetCategoryHierarchyTree } from '../../redux/lister/selectors/ListerSelector';
import { makeGetUrlFilters } from '../../redux/url/selectors/UrlSelectors';
import { getDefaultNavigationLevel, getMobileNavigationData } from '../../util/MobileNavigation.util';
import { MobileNavigation } from '../navigation/mobile-navigation/MobileNavigation';
export const MobileNavigationContainer = ({ menuConfiguration, currencies, }) => {
    const forceUpdate = useForceUpdate();
    const { t } = useTranslation([I18N_NAMESPACES.general, I18N_NAMESPACES.navigation]);
    const categoryTree = useSelector(makeGetCategoryHierarchyTree());
    const defaultFilter = useSelector(makeGetUrlFilters()).defaultFilter;
    const { categoryIds, categoryHierarchyTree } = useCategoryHierarchyTree(categoryTree, defaultFilter);
    const isClient = useIsClient();
    const { lang } = useAemConfig();
    const navigationData = useMemo(() => getMobileNavigationData(menuConfiguration, t(`${I18N_NAMESPACES.navigation}:navigation.home`)), [menuConfiguration]);
    useEffect(() => {
        if (!isClient) {
            return;
        }
        window.addEventListener(EventEnum.TARGET_MOBILE_NAV_DEPLOYED, forceUpdate);
        return () => window.removeEventListener(EventEnum.TARGET_MOBILE_NAV_DEPLOYED, forceUpdate);
    }, [isClient]);
    if (!navigationData)
        return null;
    return (_jsx(MobileNavigation, { searchConfig: { enabled: false }, accountConfig: { enabled: false }, menuItems: navigationData, currencies: currencies, defaultLevel: getDefaultNavigationLevel(categoryHierarchyTree, categoryIds, lang, navigationData) }));
};
